document.addEventListener("DOMContentLoaded", function () {
  const productFullPrice =
    +document.querySelector(".product__skio").dataset.fullPrice;
  const priceMap = JSON.parse(
    document.querySelector(".product__skio").dataset.priceMap || "{}"
  );
  const bsmsSubtitle = JSON.parse(
    document.querySelector(".product__skio").dataset.bmsmSubtitle || "{}"
  );
  const sectionId = document.querySelector(".product__skio").dataset.sectionId;
  const productHandle = document.querySelector(".product__skio").dataset.handle;
  const formId = document.querySelector(".product__skio").dataset.formId;
  const $form = document.querySelector(`#${formId}`);

  const fetchTotalQuantity = () => {
    const variants = document.querySelectorAll(".product-skio__variant");
    let totalQuantity = 0;
    Array.from(variants).forEach((variant) => {
      const qtyContainer = variant.querySelector(".product-skio__quantity");
      const quantityInp = qtyContainer.querySelector(
        ".product-skio-quantity__value"
      );
      totalQuantity += parseInt(quantityInp.value, 10);
    });
    return totalQuantity;
  };

  // Progress bar for BMSM product
  const updateProgressBar = () => {
    const progressBars = document.querySelectorAll(
      ".product-skio__progress-bar ul"
    );
    const totalQuantity = fetchTotalQuantity();

    progressBars.forEach((progressBar) => {
      progressBar.dataset.active = totalQuantity % 4;
    });

    if (totalQuantity > 4 && totalQuantity % 4 == 0) {
      progressBars[0].classList.add("d-none");
      progressBars[1].classList.remove("d-none");
      progressBars[1].dataset.active = 4;
    } else if (totalQuantity > 0 && totalQuantity % 4 == 0) {
      progressBars[0].classList.remove("d-none");
      progressBars[1].classList.add("d-none");
      progressBars[0].dataset.active = 4;
    } else if (totalQuantity > 4 && totalQuantity <= 8) {
      progressBars[0].classList.add("d-none");
      progressBars[1].classList.remove("d-none");
    } else if (totalQuantity > 0 && totalQuantity <= 4) {
      progressBars[0].classList.remove("d-none");
      progressBars[1].classList.add("d-none");
    } else if (totalQuantity > 8) {
      progressBars[0].classList.add("d-none");
      progressBars[1].classList.remove("d-none");
      progressBars[1].dataset.active = 4;
    }
  };

  const updateBmsmMessage = () => {
    const totalQuantity = fetchTotalQuantity();
    const $bmsmMessage = document.querySelector(
      ".product-skio__progress-message"
    );
    let message =
      bsmsSubtitle[totalQuantity] || bsmsSubtitle[bsmsSubtitle.length - 1];

    $bmsmMessage.textContent = message;
  };

  // add comma in the thousand place
  const addCommaNumber = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const updatePriceTable = () => {
    const subscriptionType = Object.keys(priceMap);
    const totalQuantity = fetchTotalQuantity() || 1;
    const priceTable = document.querySelector(".product-skio__plans");

    subscriptionType.forEach((type) => {
      const priceContainer = priceTable.querySelector(`label[for="${type}"]`);
      if (!priceContainer) return;
      const $fullPrice = priceContainer.querySelector(".full-price-js");
      const months = parseInt(type) || 1;
      const $subscriptionPrice = priceContainer.querySelector(
        ".subscription-price-js"
      );

      let price = type == "Monthly" ? priceMap[type][1] : productFullPrice;
      const fullPrice = (price * totalQuantity * months).toFixed(2);

      if (totalQuantity > 8) {
        const subscriptionPrice = (
          (priceMap[type][8] / 8) *
          totalQuantity
        ).toFixed(2);
        if ($fullPrice) {
          $fullPrice.textContent = `$${addCommaNumber(fullPrice)}`;
        }
        if ($subscriptionPrice) {
          $subscriptionPrice.textContent = `$${addCommaNumber(
            subscriptionPrice
          )}`;
        }
      } else if (totalQuantity == 0 || totalQuantity > 0) {
        if ($fullPrice) {
          $fullPrice.textContent = `$${addCommaNumber(fullPrice)}`;
        }
        if ($subscriptionPrice) {
          $subscriptionPrice.textContent = `$${addCommaNumber(
            priceMap[type][totalQuantity].toFixed(2)
          )}`;
        }
      }
    });
  };

  const updateFirstMonthCard = () => {
    const totalQuantity = fetchTotalQuantity();
    const $cardContainer = document.querySelector(`label[for="Monthly"]`);
    const $oneTimePrice = $cardContainer.querySelector(".onetime-price");
    const $freeShipping = $cardContainer.querySelector(".free-shipping");

    if (totalQuantity > 1) {
      $oneTimePrice.classList.add("d-none");
      $freeShipping.classList.remove("d-none");
    } else {
      $oneTimePrice.classList.remove("d-none");
      $freeShipping.classList.add("d-none");
    }
  };

  const updateAddToCartBtnState = () => {
    const addToCartBtn = document.querySelector(".product-form__submit.button");
    const totalQuantity = fetchTotalQuantity();
    if (totalQuantity > 0) {
      addToCartBtn.removeAttribute("disabled");
    } else {
      addToCartBtn.setAttribute("disabled", "disabled");
    }
  };

  const updateState = () => {
    updateProgressBar();
    updateBmsmMessage();
    updatePriceTable();
    updateFirstMonthCard();
    updateAddToCartBtnState();
  };

  const initialState = () => {
    updateAddToCartBtnState();
  };

  // Quantity controls for BMSM product
  const variants = document.querySelectorAll(".product-skio__variant");
  Array.from(variants).forEach((variant) => {
    const qtyContainer = variant.querySelector(".product-skio__quantity");
    const imageContainer = variant.querySelector(".product-skio__box-image");
    const circlePlus = qtyContainer.querySelector(
      ".product-skio-quantity__add--circle"
    );
    const controls = qtyContainer.querySelector(
      ".product-skio-quantity__controls"
    );
    const minusBtn = qtyContainer.querySelector(
      ".product-skio-quantity__minus"
    );
    const plusBtn = qtyContainer.querySelector(
      ".product-skio-quantity__add--pill"
    );
    const quantityInp = qtyContainer.querySelector(
      ".product-skio-quantity__value"
    );

    circlePlus.addEventListener("click", function () {
      circlePlus.style.display = "none";
      controls.style.display = "inline-flex";
      quantityInp.value = 1;
      imageContainer.classList.add("active");

      updateState();
    });

    // Increment quantity
    plusBtn.addEventListener("click", function () {
      let currentVal = parseInt(quantityInp.value, 10);
      quantityInp.value = currentVal + 1;

      updateState();
    });

    // Decrement quantity; if it hits 0, revert to single plus button
    minusBtn.addEventListener("click", function () {
      let currentVal = parseInt(quantityInp.value, 10);
      if (currentVal > 1) {
        quantityInp.value = currentVal - 1;
      } else {
        // revert to zero state
        quantityInp.value = 0;
        controls.style.display = "none";
        circlePlus.style.display = "flex";
        imageContainer.classList.remove("active");
      }

      updateState();
    });

    initialState();
  });

  const retrieveSubscriptionId = () => {
    const sellingPlanGroups = JSON.parse(
      document.querySelector(".product__skio").dataset.sellingPlanGroups
    );
    const variantTitle = document.querySelector(`[name="plan"]:checked`).value;

    let planId = null;
    for (let i = 0; i < sellingPlanGroups.length; i++) {
      const group = sellingPlanGroups[i];
      for (let j = 0; j < group.selling_plans.length; j++) {
        const plan = group.selling_plans[j];
        if (plan.name === variantTitle) {
          planId = plan.id;
        }
      }
    }

    return planId;
  };

  const getQuantityAndLineItemPropertyTitle = () => {
    const variants = document.querySelectorAll(".product-skio__variant");
    const variantTitleAndQuantity = Array.from(variants).reduce(
      (obj, variant) => {
        const qtyContainer = variant.querySelector(".product-skio__quantity");
        const quantityInp = qtyContainer.querySelector(
          ".product-skio-quantity__value"
        );
        const variantTitle = variant.dataset.lineItemProperty;
        const quantity = parseInt(quantityInp.value, 10);
        if (quantity <= 0) return obj;
        return {
          ...obj,
          [variantTitle]: quantity,
        };
      },
      {}
    );

    const totalQuantity = fetchTotalQuantity();

    const selectedSubscriptionId = retrieveSubscriptionId();
    const variantId = document.querySelector(`[name="plan"]:checked`).dataset.variantId;

    variantTitleAndQuantity["_bulk_bundle_discount_name"] = window.variantDiscountName;

    return {
      id: variantId,
      quantity: totalQuantity,
      selling_plan: selectedSubscriptionId,
      "section-id": sectionId,
      sections: "cart-notification-product,cart-notification-button,cart-icon-bubble",
      sections_url: productHandle,
      properties: variantTitleAndQuantity,
    };
  };

  // Add to cart logic
  const addToCartBtn = document.querySelector(
    `button.product-form__submit[name="add"]`
  );
  addToCartBtn.addEventListener("click", function (evt) {
    evt.preventDefault();
    const item = getQuantityAndLineItemPropertyTitle();

    let formData = {
      items: [item],
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("---- Success ----");
        console.log(data);
        const cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        cart.renderContents(data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  });

  // Update variant change 
  const planContainer = document.querySelector(".product-skio__plans");
  const planInputs = planContainer.querySelectorAll(`[name="plan"]`);
  planInputs.forEach((input) => {
    input.addEventListener("change", function (evt) {
      const selectedPlan = evt.target;
      const isChecked = selectedPlan.checked;

      if(isChecked) {
        const detail = {
          variant: {
            id: selectedPlan.dataset.variantId,
          }
        };
        document.dispatchEvent(new CustomEvent('variant:change', { detail }));
      }
    });
  });
});
